import * as React from 'react';
import * as classNames from 'classnames';

import style from './process.less';
import { WProcessStepConfig, WProcessStep } from './WProcessStep';

interface WProcessProps extends React.ClassAttributes<any> {
    name: string;
    step: number;
    steps: Array<WProcessStepConfig>;
    locked?: boolean;
    onStepChange: (step: number) => void;
}

export class WProcess extends React.Component<WProcessProps, {}> {

    constructor(props: any) {
        super(props);
    }

    private stepElements: Array<JSX.Element> = new Array<JSX.Element>();

    componentWillMount() {
        // Steps aus Konfig erstellen
        this.props.steps.forEach((s: any) => {
            const step = (
                <WProcessStep
                    name={s.name}
                    component={s.component}
                />
            );
            this.stepElements.push(step);
        });
    }

    render() {
        return (
            <div className={style.colContainer}>
               <div className={classNames(style.flexItem, style.processHead)}>
                    <div className={style.rowContainer}>
                         {this.props.steps.map((e, idx) => {
                            const cls = !this.props.locked && idx <= this.props.step ? style.stepHead : style.stepHeadInactive;
                            return (
                                <div
                                    key={`proc_${idx}`}
                                    className={classNames(style.flexItem, cls)}
                                    onClick={!this.props.locked && idx < this.props.step ? () => this.props.onStepChange(idx) : () => {}}
                                >
                                {e.name}
                                </div>
                            );
                        })}
                    </div>
               </div>
               <div className={classNames(style.flexItem, style.processBody)}>
                {!this.stepElements || this.stepElements.length <= this.props.step
                    ? 'Ungültige Prozess-Konfiguration!'
                    : this.stepElements[this.props.step]
                }
               </div>
            </div>
        );
    }
}
